<template>
  <div class="page-content">
    <div class="row justify-content-center mt-20">
      <el-radio-group v-model="emailTemplateType">
        <el-radio-button label="gogoTemplate">
          GoGo Template Emails
        </el-radio-button>
        <el-radio-button label="sendgridTemplate">
          SendGrid Template Emails
        </el-radio-button>
      </el-radio-group>
    </div>

    <display-go-go-email-example v-if="emailTemplateType === 'gogoTemplate'" />
    <display-send-grid-email-example v-if="emailTemplateType === 'sendgridTemplate'" />
  </div>
</template>

<script setup lang="ts">
import { ref, defineAsyncComponent } from 'vue';

const DisplayGoGoEmailExample = defineAsyncComponent(() => import('./DisplayEmailExample/DisplayGoGoEmailExample.vue') as any);

const DisplaySendGridEmailExample = defineAsyncComponent(() => import('./DisplayEmailExample/DisplaySendGridEmailExample.vue') as any);

const emailTemplateType = ref('gogoTemplate');
</script>
